import {StyledGrid} from 'presentation/components';
import React from 'react';
import {ExamCard} from '../ExamCard';
import {ExamCardsGridType} from './types';

export const ExamCardsGrid = ({list, isWaitingResult}: ExamCardsGridType) => (
	<StyledGrid.Root spacing={2}>
		{list?.map((card, index) => (
			<StyledGrid.Item key={index} xs={12} sm={12} md={6} lg={4} xl={4}>
				<ExamCard exam={card} isWaitingResult={isWaitingResult} />
			</StyledGrid.Item>
		))}
	</StyledGrid.Root>
);
